module.exports = __webpack_public_path__ + "img/jelly3.d500fd3e.jpg";